import React, { useEffect, useState } from 'react';

import { NepaliDatePicker } from 'nepali-datepicker-reactjs';

import axios from 'axios';
import URL from '../constants/ServerUrl';
import { useNavigate,useSearchParams } from 'react-router-dom';
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'

const Payments = () => {
  const [startDate, setStartDate] = useState(convertDateToBS(Date.now() - 30 * 24 * 60 * 60 * 1000))
  const [endDate, setEndDate] = useState(convertDateToBS(Date.now()))
  const [tableData, setTableData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const token = localStorage.getItem("dairy-token")
  const history = useNavigate();
  const onChangeStart = ( date) => {
    setStartDate(date)
  }

  const onChangeEnd = ( date) => {
    setEndDate(date)
  }

  const fetchPayments = async () => {
    try {
      if (username) {
        setIsLoading(true);
        const farmers = await axios.get(`${URL}admin/${username}/farmer`,{
          Authorization: `Bearer ${token}`
        });
        const farmersArray = farmers.data.map((farmer) => ({
          farmerName: farmer.farmerName,
          farmerId: farmer.farmerId,
        }));

        const farmersMap = farmersArray.reduce((acc, farmer) => {
          acc[farmer.farmerId] = farmer.farmerName;
          return acc;
        }, {});

        if (farmers.data) {
          let start = convertDateToAD(startDate)
          let end = convertDateToAD(endDate)
          const payments = await axios.get(
            `${URL}admin/${username}/payment?startDate=${start}&endDate=${end}`
          ,{
            Authorization: `Bearer ${token}`
          });

          payments.data.forEach((payment) => {
            if (!payment.farmerName) {
              payment.farmerName = farmersMap[payment.farmerId - '0'];
            }
            // You may need to format the date here as per your requirements
            payment.date = convertDateToBS(payment.date);
          });

          setFilteredTableData(payments.data);
          setTableData(payments.data);
          setIsLoading(false);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, [startDate, endDate, username]);

  const handleSearch = (text) => {
    setSearch(text);

    if (text === '') return setFilteredTableData(tableData);

    const filteredData = tableData.filter((item) => {
      return item.farmerName.toLowerCase().startsWith(text.toLowerCase());
    });
    setFilteredTableData(filteredData);
  };

  const navigateToAddPayments = () => {
    history(`AddPayments?username=${username}`)
  };


  return (
    <div class="container mx-auto p-6 bg-green-50 text-gray-800">
       <h1 className="text-2xl font-bold text-center text-blue-600 mb-6">Payments</h1>
    <form className="mb-6">
    <div class="flex space-x-4 mb-4">
  <div class="relative">
    <label for="startDate" class="block text-sm font-medium text-gray-700">From</label>
    <div class="mt-1">
      <NepaliDatePicker
        id="startDate"
        className="border border-gray-300 rounded-md px-4 py-2 w-full"
        value={startDate}
        onChange={onChangeStart}
        options={{ calenderLocale: 'en', valueLocale: 'en' }}
      />
    </div>
  </div>
  <div class="relative">
    <label for="endDate" class="block text-sm font-medium text-gray-700">To</label>
    <div class="mt-1">
      <NepaliDatePicker
        id="endDate"
        className="border border-gray-300 rounded-md px-4 py-2 w-full"
        value={endDate}
        onChange={onChangeEnd}
        options={{ calenderLocale: 'en', valueLocale: 'en' }}
      />
    </div>
  </div>
</div>

<div className="flex justify-between items-center mb-4">


      <input
        className="border border-gray-300 rounded px-4 py-2 w-full"
        label="Search by name"
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
        variant="outlined"
        placeholder="Search by name..."
      />
      
    <button
  className="bg-green-500 text-white px-4 py-2 rounded"
      onClick={navigateToAddPayments}
    >
      Add Payment
    </button>

    </div>
    </form>

    <div className="mb-6">
      <table class="min-w-full bg-white border border-gray-300 rounded-lg shadow">
        <thead>
          <tr>
            <th className="px-6 py-3 bg-gray-100 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
            <th className="px-6 py-3 bg-gray-100 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Id
            </th>
            <th className="px-6 py-3 bg-gray-100 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Name
            </th>
            <th className="px-6 py-3 bg-gray-100 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Amount
            </th>
            <th className="px-6 py-3 bg-gray-100 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Remarks
            </th>
            <th className="px-6 py-3 bg-gray-100 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Operations
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Render rows of payment data */}
          {isLoading ? (
            <tr>
              <td colSpan={5}>Loading Payments...</td>
            </tr>
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan={5}>No Payments Found</td>
            </tr>
          ) : (
            filteredTableData.map((item) => (
                <tr key={item._id}>
                <td className="border px-6 py-4">{item.date}</td>
                <td className="border px-6 py-4">{item.farmerId}</td>
                <td className="border px-6 py-4">{item.farmerName} </td>
                <td className="border px-6 py-4">{item.amountToPay}</td>
                <td className="border px-6 py-4">{item.remarks}</td>
                <td className="border px-6 py-4">
  <button
    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:border-red-300"
    onClick={() => history(`EditPayment?username=${username}&id=${item._id}`)}
  >
    Edit Payment
  </button>
</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>

  </div>
  );
};

export default Payments;
